<app-customer-catalogs
    *ngIf="element.FilteredCustomerCatalogs"
    [permissionKey]="'sale.customerCatalogs.list'"
    [(customerCatalogs)]="element.FilteredCustomerCatalogs"
    (onPrepareRow)="onNewElement($event)"
    (beforeAdd)="onBeforeInserting($event)"
    (beforeDelete)="onBeforeDelete($event)"
    (beforeUpdate)="onBeforeUpdate($event)"
></app-customer-catalogs>